import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/rabbits", label: "Available" },
  { to: "/care-guide", label: "Care Guide" },
  { to: "/guarantee", label: "Guarantee" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-40 border-b border-border bg-[#FAF8F5]/85 backdrop-blur-xl"
      data-testid="site-navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-12">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="h-9 w-9 rounded-full bg-terracotta" />
          <div className="leading-tight">
            <div className="font-serif text-xl text-foreground">Alabama Lion's Mane</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-sage">Rabbitry · Est. 2026</div>
          </div>
        </Link>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wide ${
                  isActive ? "text-terracotta" : "text-foreground/80 hover:text-foreground"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/rabbits"
            data-testid="nav-cta-reserve"
            className="rounded-full bg-terracotta px-5 py-2 text-sm text-white transition-transform hover:-translate-y-0.5"
          >
            Reserve a Rabbit
          </Link>
        </nav>
        <button
          className="lg:hidden text-foreground"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-border bg-background lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1 px-6 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-2 text-base ${isActive ? "text-terracotta" : "text-foreground/80"}`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
